import * as React from 'react';
import { ReactComponent as AdminIcon } from '../../Assets/images/profile-admin.svg';
import { ReactComponent as WorkerIcon } from '../../Assets/images/profile-worker.svg';
import { ReactComponent as CustomerIcon } from '../../Assets/images/profile-customer.svg';
import './Profile.scss';
import BoxProfile from './BoxProfile';
import ChangePass from './ChangePass';
import { IPassword } from '../../Models/Security';

export interface IProfileProps {
	className?: string;
	name: string;
	email: string;
	profile: string;
	onChange: (password: IPassword) => void;
}

enum EProfile {
	Admin = 'profile-admin',
	Customer = 'profile-customer',
	Worker = 'profile-worker'
}
let node: any = undefined;
const Profile = (props: IProfileProps) => {

	const [isOpen, setOpen] = React.useState(false);
	const [openChange, setOpenChange] = React.useState(false);
	const close = () => {
		setOpen(false);
		document.removeEventListener('click', listener);
	};
	const listener = (evt: any) => {
		if (!node || !node.contains(evt.target)) {
			close();
		}
	};
	const toggle = () => {
		if (!isOpen) {
			document.addEventListener('click', listener);
		}
		setOpen(!isOpen);
	}
	const getProfile = () => {
		if (props.profile.toLowerCase().indexOf('admin') >= 0) {
			return EProfile.Admin;
		}
		if (props.profile.toLowerCase().indexOf('person') >= 0) {
			return EProfile.Worker;
		}
		return EProfile.Customer;
	}
	const profileClass = getProfile();
	const renderIcon = () => {
		switch(profileClass) {
			case EProfile.Worker:
				return <WorkerIcon />;
			case EProfile.Admin:
				return <AdminIcon />;
			default:
				return <CustomerIcon />;
		}
	}

	const onChangePass = () => {
		close();
		setOpenChange(!openChange);
	}

	return (<div ref={n => {node = n}} onClick={!isOpen ? toggle : undefined} className={`profile ${props.className}`} >
		<BoxProfile
			name={props.name}
			profile={props.profile}
			email={props.email}
			classProfile={profileClass}
			icon={renderIcon()}
			onToggle={toggle}
			open={isOpen}
			onChangePass={onChangePass}
		/>
		<ChangePass isOpen={openChange} onClose={onChangePass} email={props.email} onChange={props.onChange} />
		<div className="profile-box-info">
			<div className="profile-box-info-name">{props.name}</div>
			<div className="profile-box-info-email">{props.email}</div>
			<div className={`profile-box-info-role ${profileClass}`}>{props.profile}</div>
		</div>
		<div className={`profile-icon ${profileClass}`}>
			{renderIcon()}
		</div>
	</div>)
}

export default Profile;
